import React from "react"
import { cx } from "lib/helpers"

interface CheckMarkProps {
  color?: string
  className?: string
}

const CheckMark = ({
  color = `#000`,
  className,
  ...otherProps
}: CheckMarkProps) => (
  <div
    {...otherProps}
    className={cx(
      `inline-block transform rotate-45 h-5 w-2.5 border-b-[3px] border-r-[3px] border-[${color}]`,
      className
    )}
  />
)

export default CheckMark
